import zip from 'lodash/zip'
import api from '@/services/api'
import _ from 'lodash'
import prepareEntries from './prepareEntries'

export default async function(entries, { eventId, token }) {
    const errorLists = await getAllErrors(entries, { eventId, token })

    zip(entries, errorLists).forEach(([ entry, errors ], index) => {
        errors.forEach(error => {
            error.lineNumber = index + 1 + 1 // +1 for one-indexing, +1 to account for the header line
            error.entry = entry
        })
    })
    return errorLists.reduce((all, next) => [ ...all, ...next ], [])
}

async function getAllErrors(entries, { eventId, token }) {
    try {
        await api.post(
            `/api/v1/rostering/${eventId}/${token}/validate`,
            { athletes: prepareEntries(entries) },
        )
        return Array(entries.length).fill([])
    } catch (e) {
        const response = await e.response
        return entries.map((entry, index) => getEntryErrors(entry, index, response))
    }
}

function getEntryErrors(entry, index, response) {
    const prefix = `athletes.${index}.`

    return _(response.errors)
        .pickBy((value, key) => _.startsWith(key, prefix))
        .mapValues((messages, key) => ({ fieldName: key.replace(prefix, ''), messages }))
        .values()
        .flatMap(({ fieldName, messages }) => (
            messages.map(message => ({ fieldName, message: message.replace(prefix, '') }))
        ))
        .value()
}
